<template>
  <div>
    <v-dialog v-model="show" :width="width" @close="close" @click:outside="close">
      <v-card>
        <v-card-title v-html="title"/>
        <v-card-text v-html="message"/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click="close">{{ $t('ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'GlobalModal',
  data () {
    return {
      show: false,
      title: '',
      message: '',
      width: 450
    }
  },
  computed: {
    ...mapState('globalMessagingModule', {
      modal: state => state.modal
    })
  },
  methods: {
    close () {
      this.$store.dispatch('globalMessagingModule/hideModal')
    }
  },
  watch: {
    modal (modal, oldValue) {
      if (modal != null) {
        this.message = modal.message
        this.title = modal.title || this.$t('error')
        this.show = true
      } else {
        this.show = false
      }
    }
  }
}
</script>
